import React from 'react';

import AboutSeller from '../components/DisputeDetails.tsx/Sections/AboutSeller';
import AboutBuyer from '../components/DisputeDetails.tsx/Sections/AboutBuyer';
import DisputedProducts from '../components/Dispute/DisputedProducts';
import DisputesStats from '../components/DisputeDetails.tsx/Sections/DisputesStats';
import BuyerDisputeModal from '../components/DisputeDetails.tsx/atoms/DisputeActionModal';
import OrderPaymentSummary from '../components/DisputeDetails.tsx/Sections/OrderPaymentSummary';
import { useParams } from 'react-router-dom';
import DisputeChatSection from '../components/Dispute/Common/DisputeChatSection';
import Summary from '@/components/DisputeDetails.tsx/Sections/Summary';
import ActionsPreview from '@/components/Dispute/Common/ActionsPreview';

const DisputeDetails = () => {
  const { disputeId } = useParams<{ disputeId: string }>();

  return (
    <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div className="col-span-3">
          <DisputesStats />
        </div>

        {/* Col 1 */}
        <div className="col-span-3 flex flex-col gap-6 md:col-span-2 md:col-start-1">
          {disputeId && <DisputeChatSection disputeId={disputeId} />}

          <Summary />

          <DisputedProducts />
        </div>

        {/* Col 2 */}
        <div className="flex flex-col gap-6 col-span-3 md:col-span-1 md:col-start-3">
          <ActionsPreview />

          <AboutSeller />

          <AboutBuyer />

          <OrderPaymentSummary />
        </div>

        <BuyerDisputeModal />
      </div>
    </>
  );
};

export default DisputeDetails;
